import gql from 'graphql-tag';
import { orderBy } from 'lodash';
import { apollo } from 'src/features';
import { formattedMessage } from 'src/utils';

const query = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
      gender
      birthdate
      accounts {
        id
        provider
        providerId
      }
    `;
  return gql`
  query Activity($id: ID!) {
    activity(id: $id) {
      id
      state
      channelName
      channelType
      insertedAt
      appealId
      duration
      avatarUrl
      channel {
        id
        type
        identifier
      }
      markers {
        id
        name
        directory {
          id
          name
        }
      }
      requestType {
        id
        name
        description
        defaultType
        active
      }
      case {
        id
        name
        description
        insertedAt
        updatedAt
        comment
      }
      customer {
        ${privateCustomerData}
        id
        firstName
        vip
        description
        identified
        customInfo {
          label
          value
        }
      }
      operator {
        id
        name
        firstName
        lastName
        middleName
        displayName
        avatarUrl
      }
      messages {
        id
        sender
        insertedAt
        body
        isRead
        customerId
        operatorId
        activityId
        receiver
        avatarUrl
        to
        from
        copies
        auto
        attachments {
          title
          type
          size
          original
          preview
          ext
        }
      }
      isAuthorized
      noAuthorized
    }
  }`;
};

export function parseActivity(item) {
  let customerType = 'anon';
  if (item.customer.identified) {
    customerType = item.channelType;
    if (item.channelType === 'web') customerType = 'client';
  }
  let { messages } = item;

  if (messages) { // signal newActivity without messages
    const currentID = Number(item?.case?.id);
    messages = orderBy(messages.map((message) => ({
      ...message,
      insertedAt: new Date(message.insertedAt),
      customerType,
    })).map((msg) => formattedMessage(msg, customerType, currentID)), 'insertedAt');
  }

  return {
    ...item,
    messages,
  };
}

function getActivity(id, isExternalOperator = false) {
  return apollo.client.query({
    variables: { id },
    query: query(isExternalOperator),
    fetchPolicy: 'network-only',
  }).then((res) => parseActivity(res.data.activity));
}

export default getActivity;
